import { render, staticRenderFns } from "./SupplierSettingsOrganizationTab.vue?vue&type=template&id=f8ae22ea&"
import script from "./SupplierSettingsOrganizationTab.vue?vue&type=script&lang=js&"
export * from "./SupplierSettingsOrganizationTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports